import { ComponentTypes } from '../../../interfaces/components';
import {
  CmsAccordion,
  CmsDynamicYield,
  CmsGroup,
  CmsHeadline,
  CmsInstallmentCalculator,
  CmsRecommendation,
  CmsCarousel,
  CmsImage,
  ExternalScript,
  FlexibleTeaser,
  Html,
  LinkByButton,
  LinkBox,
  LinkByText,
  LegacyNewsletter,
  ModalByButton,
  NewsletterUnsubscribe,
  Placeholder,
  SectionSeperator,
  Voucher,
  Video,
} from '..';
import { registerComponents } from './componentRegistry';

/**
 * Registers a set of components using the previously defined registerComponent function.
 * don't forget to register the dynamic components if <ComponentRecognizer /> is in use. Example:
 * ```
 *    import { registerFlexibleComponents } from '@packages/cms-components/src/components/ComponentRecognizer/registerFlexibleComponents';
 *    registerFlexibleComponents();
 * ```
 */
export const registerFlexibleComponents = (): void => {
  registerComponents({
    [ComponentTypes.Html]: Html,
    [ComponentTypes.Placeholder]: Placeholder,
    [ComponentTypes.Group]: CmsGroup,
    [ComponentTypes.GroupLocalizable]: CmsGroup,
    [ComponentTypes.SvgFile]: CmsImage,
    [ComponentTypes.ImageSimple]: CmsImage,
    [ComponentTypes.Headline]: CmsHeadline,
    [ComponentTypes.Accordion]: CmsAccordion,
    [ComponentTypes.AccordionLocalizable]: CmsAccordion,
    [ComponentTypes.LinkByButton]: LinkByButton,
    [ComponentTypes.LinkByText]: LinkByText,
    [ComponentTypes.LinkBox]: LinkBox,
    [ComponentTypes.DynamicYield]: CmsDynamicYield,
    [ComponentTypes.RecoPrudsys]: CmsRecommendation,
    [ComponentTypes.SectionSeperator]: SectionSeperator,
    [ComponentTypes.FlexibleTeaser]: FlexibleTeaser,
    [ComponentTypes.InstallmentCalculator]: CmsInstallmentCalculator,
    [ComponentTypes.ButtonModal]: ModalByButton,
    [ComponentTypes.Liveshopping]: ExternalScript,
    [ComponentTypes.ExternalScript]: ExternalScript,
    [ComponentTypes.ExternalScriptHappyContest]: ExternalScript,
    [ComponentTypes.ExternalScriptLoadbee]: ExternalScript,
    [ComponentTypes.Newsletter]: LegacyNewsletter,
    [ComponentTypes.NewsletterUnsubscribe]: NewsletterUnsubscribe,
    [ComponentTypes.VoucherList]: Voucher,
    [ComponentTypes.Video]: Video,
    [ComponentTypes.Carousel]: CmsCarousel,
  });
};
